import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../assets/logo-cpuc.png';

const telephonieLinks = [
  { to: '/telephonie-ip', label: 'Offre de service' },
  { to: '/telephonie-ip/sms', label: 'Textos' },
  { to: '/telephonie-ip/fax', label: 'Fax' },
  { to: '/telephonie-ip/equipements', label: 'Équipements' },
];

const a_proposLinks = [
  { to: '/simplicite', label: 'Simplicité' },
  { to: '/a-propos', label: 'À propos de nous' },
  { to: '/politique-confidentialite', label: 'Politique de confidentialité' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [telOpen, setTelOpen] = useState(false);
  const [aProposOpen, setAProposOpen] = useState(false);
  const close = () => { setOpen(false); setTelOpen(false); setAProposOpen(false); };

  return (
    <nav className="navbar navbar-expand-lg sticky-top bg-white shadow-sm">
      <div className="container py-2">
        <Link className="navbar-brand d-flex align-items-center" to="/" onClick={close}>
          <img src={logo} alt="CPUc Solutions Technologiques" className="logo-img" />
        </Link>

        <button className="navbar-toggler border-0" type="button" onClick={() => setOpen(!open)}>
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${open ? 'show' : ''}`} id="mainNav">
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-4 py-3 py-lg-0">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={close}>Accueil</NavLink>
            </li>

            <li className={`nav-item dropdown ${telOpen ? 'show' : ''}`}>
              <span className="nav-link dropdown-toggle" role="button" onClick={() => setTelOpen(!telOpen)}>
                Téléphonie
              </span>
              <ul className={`dropdown-menu ${telOpen ? 'show' : ''}`}>
                {telephonieLinks.map((l) => (
                  <li key={l.to}>
                    <NavLink className="dropdown-item" to={l.to} end onClick={close}>{l.label}</NavLink>
                  </li>
                ))}
              </ul>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/services" onClick={close}>Nos services</NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/technologies" onClick={close}>Nos technologies</NavLink>
            </li>

            <li className={`nav-item dropdown ${aProposOpen ? 'show' : ''}`}>
              <span className="nav-link dropdown-toggle" role="button" onClick={() => setAProposOpen(!aProposOpen)}>
                Notre histoire
              </span>
              <ul className={`dropdown-menu dropdown-menu-end ${aProposOpen ? 'show' : ''}`}>
                {a_proposLinks.map((l) => (
                  <li key={l.to}>
                    <NavLink className="dropdown-item" to={l.to} onClick={close}>{l.label}</NavLink>
                  </li>
                ))}
              </ul>
            </li>

            <li className="nav-item">
              <Link className="btn btn-outline-brand rounded-pill px-4" to="/contact" onClick={close}>
                Contactez-nous
              </Link>
            </li>

            <li className="nav-item mt-2 mt-lg-0">
              <Link className="btn btn-support rounded-pill px-4" to="/support" onClick={close}>
                Support
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}